import {
  EKycVerificationStatus,
  ExamEventExamineeCertificateStatus,
  ExamEventExamineeStatus,
  ExamType,
  RegistrationStatus,
} from '@exam-center/graphql';

export const PRINTABLE_REGISTRATION_STATUSES = [
  RegistrationStatus.RegistrationClosed,
  RegistrationStatus.TemporarilyClosed,
  RegistrationStatus.SessionFull,
];

export const PRINTABLE_EXAM_TYPES = [ExamType.Computer];

export const GENERATE_SEAT_NUMBER_REGISTRATION_STATUSES = [
  RegistrationStatus.TemporarilyClosed,
  RegistrationStatus.SessionFull,
  RegistrationStatus.RegistrationClosed,
  RegistrationStatus.OpenForRegistration,
];

export const EKYC_RE_SENDABLE_REGISTRATION_STATUSES = [
  RegistrationStatus.OpenForRegistration,
  RegistrationStatus.RegistrationClosed,
  RegistrationStatus.TemporarilyClosed,
  RegistrationStatus.SessionFull,
];

export const EKYC_RE_SENDABLE_EKYC_STATUSES = [
  EKycVerificationStatus.NotStarted,
  EKycVerificationStatus.InProgress,
  EKycVerificationStatus.Rejected,
  EKycVerificationStatus.Expired,
];

export const EKYC_RE_SENDABLE_EXAM_EVENT_EXAMINEE_STATUS = [ExamEventExamineeStatus.PrepareForExam];

export const RESEND_CERTIFICATE_STATUSES = [ExamEventExamineeCertificateStatus.Sent];
